import { Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import { ArticleCard } from '@/components/feature/ArticleCard';
import { categories } from '@/mocks/categories';
import { getHotArticles, getLatestArticles, getExclusiveArticles, articles } from '@/mocks/articles';
import Newsletter from './components/Newsletter';

export default function Home() {
  const hotArticles = getHotArticles();
  const latestArticles = getLatestArticles(8);
  const exclusiveArticles = getExclusiveArticles();
  const featuredArticle = hotArticles[0];
  const secondaryHot = hotArticles.slice(1, 3);
  const trendingArticles = articles
    .sort((a, b) => b.viewCount - a.viewCount)
    .slice(0, 5);

  return (
    <>
      <SEOHead
        title="黑料网 - 最新黑料爆料平台"
        description="黑料网是专注于娱乐圈、网红明星黑料爆料的内容聚合平台，汇集最新最全的黑料资讯、独家爆料内容，让你第一时间掌握圈内热门黑料动态，关注黑料网获取持续更新的真实爆料信息。"
        keywords="黑料网,黑料网最新爆料,黑料网明星八卦,黑料网网红爆料,黑料网独家内容,娱乐圈黑料,明星黑料爆料平台"
        canonicalUrl="/"
      />

      {/* Hero Section */}
      <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20dark%20cityscape%20at%20night%20with%20warm%20amber%20and%20red%20accent%20lights%2C%20mysterious%20atmosphere%2C%20paparazzi%20flash%20effects%2C%20luxurious%20urban%20night%20scene%2C%20film%20noir%20aesthetic%2C%20celebrity%20culture%20theme%2C%20dramatic%20contrast%20between%20light%20and%20shadow&width=1800&height=800&seq=hero-bg-main&orientation=landscape"
            alt="黑料网"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/70"></div>
        </div>
        <div className="relative z-10 w-full px-4 md:px-6 pt-16">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-200 text-sm mb-6">
              <i className="ri-fire-line"></i>
              <span>实时更新 · 最新爆料</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
              娱乐圈<strong className="text-primary-400">黑料</strong>第一站
            </h1>
            <p className="mt-6 text-lg md:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed">
              聚焦娱乐圈明星八卦、网红爆料、独家内幕，让你第一时间掌握圈内热门黑料动态，获取持续更新的真实爆料信息
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
              <Link
                to="/category/dujia-neirong"
                className="px-8 py-3.5 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-vip-crown-line"></i>
                查看独家爆料
              </Link>
              <Link
                to="/category/mingxing-bagua"
                className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-full font-medium text-sm hover:bg-white/20 transition-all duration-300 whitespace-nowrap"
              >
                浏览明星八卦
              </Link>
            </div>
            <div className="flex items-center justify-center gap-8 mt-10 text-white/50 text-xs">
              <span className="flex items-center gap-1.5">
                <i className="ri-article-line"></i>1,500+ 篇爆料
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line"></i>日活 50万+
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-user-smile-line"></i>真实爆料来源
              </span>
            </div>
          </div>
        </div>
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-white/40 text-2xl"></i>
        </div>
      </section>

      {/* Hot Topics Bar */}
      <section className="w-full bg-background-100 border-b border-background-200/70">
        <div className="w-full px-4 md:px-6 py-3">
          <div className="max-w-7xl mx-auto flex items-center gap-3">
            <span className="flex items-center gap-1.5 text-sm font-medium text-primary-600 whitespace-nowrap">
              <i className="ri-fire-line"></i>热门话题
            </span>
            <div className="flex items-center gap-2 overflow-x-auto flex-nowrap">
              {['恋情曝光', '偷税漏税', '综艺内幕', '整容风波', '学历造假', '直播翻车', '合约纠纷', '片面爆料'].map((tag) => (
                <Link
                  key={tag}
                  to={`/category/mingxing-bagua`}
                  className="px-3 py-1 text-xs bg-background-50 text-foreground-700 rounded-full border border-background-200 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Featured Hot Article */}
      {featuredArticle && (
        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                头条爆料
              </h2>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2">
                <ArticleCard article={featuredArticle} variant="featured" />
              </div>
              <div className="flex flex-col gap-4">
                {secondaryHot.map((article) => (
                  <ArticleCard key={article.id} article={article} variant="horizontal" />
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Category Navigation */}
      <section className="w-full bg-background-100 px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              内容分类
            </h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <span className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-500 text-center">{cat.description}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Articles */}
      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-3">
              <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                最新爆料
              </h2>
            </div>
            <Link
              to="/category/mingxing-bagua"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {latestArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>

      {/* Exclusive Content */}
      {exclusiveArticles.length > 0 && (
        <section className="w-full bg-background-100 px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                独家内容
              </h2>
              <span className="px-2.5 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full">
                黑料网原创
              </span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
              {exclusiveArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Trending Ranking */}
      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门排行
            </h2>
          </div>
          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
            {trendingArticles.map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className={`flex items-center gap-4 p-4 hover:bg-background-100 transition-colors ${
                  index < trendingArticles.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  index === 0 ? 'bg-primary-500 text-white' :
                  index === 1 ? 'bg-primary-400 text-white' :
                  index === 2 ? 'bg-primary-300 text-primary-900' :
                  'bg-background-200 text-foreground-600'
                }`}>
                  {index + 1}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 line-clamp-1 hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-1 text-xs text-foreground-500">
                    <span>{article.categoryName}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>{(article.viewCount / 10000).toFixed(1)}万阅读
                    </span>
                  </div>
                </div>
                {article.isHot && (
                  <span className="hidden sm:inline-flex items-center gap-0.5 px-2 py-0.5 text-xs bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">
                    <i className="ri-fire-line text-xs"></i>热门
                  </span>
                )}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <Newsletter />
    </>
  );
}